var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508 508",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "121.2,83.2 121.2,424.4 330.4,424.4 330.4,368.4 386.8,368.4 386.8,83.2 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#355b9c"
    },
    points: "330.4,424.4 386.8,368.4 330.4,368.4 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.8,
    y: 111.6,
    style: {
      fill: "#FF7058"
    },
    width: 39.6,
    height: 39.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.8,
    y: 166.8,
    style: {
      fill: "#ffffff"
    },
    width: 39.6,
    height: 39.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.8,
    y: 221.6,
    style: {
      fill: "#324A5E"
    },
    width: 39.6,
    height: 39.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.8,
    y: 276.8,
    style: {
      fill: "#84DBFF"
    },
    width: 39.6,
    height: 39.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.8,
    y: 111.6,
    style: {
      fill: "#355b9c"
    },
    width: 152.4,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.8,
    y: 129.6,
    style: {
      fill: "#355b9c"
    },
    width: 92.4,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.8,
    y: 166.8,
    style: {
      fill: "#355b9c"
    },
    width: 152.4,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.8,
    y: 184.8,
    style: {
      fill: "#355b9c"
    },
    width: 92.4,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.8,
    y: 221.6,
    style: {
      fill: "#355b9c"
    },
    width: 152.4,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.8,
    y: 240,
    style: {
      fill: "#355b9c"
    },
    width: 92.4,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.8,
    y: 276.8,
    style: {
      fill: "#355b9c"
    },
    width: 152.4,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.8,
    y: 294.8,
    style: {
      fill: "#355b9c"
    },
    width: 92.4,
    height: 8.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTake);
export default __webpack_public_path__ + "static/media/take.df1674d09a1a17081098afa735e85e87.svg";
export { ForwardRef as ReactComponent };